// src/components/ui/AvatarCircle.tsx
import React from "react";

interface AvatarCircleProps {
  /** avatarId corresponds to a file in /public/avatars/, e.g. "avatar_capybara_boy" */
  avatarId?: string | null;

  /** pixel size of the circle (default 40 for mini header version) */
  size?: number;

  /** optional click handler (for opening settings, etc.) */
  onClick?: () => void;

  /** additional Tailwind classnames */
  className?: string;

  /** accessible label for the avatar button */
  ariaLabel?: string;

  /** id of helper text that describes the avatar button */
  ariaDescribedBy?: string;
}

export default function AvatarCircle({
  avatarId,
  size = 40,
  onClick,
  className = "",
  ariaLabel,
  ariaDescribedBy,
}: AvatarCircleProps) {
  // Proper default fallback file
  const file = avatarId ? `${avatarId}.png` : "avatar_default.png";
  const src = `/avatars/${file}`;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      className={`
        rounded-full overflow-hidden flex items-center justify-center
        focus:outline-none focus:ring-2 focus:ring-gray-300
        transition
        ${onClick ? "cursor-pointer" : "cursor-default"}
        ${className}
      `}
      style={{ width: size, height: size, minWidth: size, minHeight: size }}
    >
      <img
        src={src}
        alt="User avatar"
        className="object-cover w-full h-full"
        draggable={false}
        onError={(e) => {
          // fallback if file missing
          (e.target as HTMLImageElement).src = "/avatars/avatar_default.png";
        }}
      />
    </button>
  );
}
